import { ExclamationTriangleIcon } from "@heroicons/react/24/outline";
import {
    Avatar,
    Button,
    Card,
    CardBody,
    Divider,
    Modal,
    ModalBody,
    ModalContent,
    ModalFooter,
    ModalHeader,
} from "@heroui/react";
import React from "react";
import { useTranslation } from "react-i18next";
import { MarketplaceCardResponseDto, ViewModalProps } from "../../../types/types";
import { formatPurseText, getCurrencySymbol } from "../../../utils/opportunityAndReadyroster";
import { formatEnumString, formatSportName, formatWeightClassName } from "../../../utils/utilMethods";

import { ReportAbusePopup } from "../../../Pages/abuseReport/reportAbusePopup";
import ConfirmModal from "../../common/confirmModal";
import CalendarView from "./calendarView";

const ViewModal: React.FC<ViewModalProps> = ({
    isOpen,
    onClose,
    viewCard,
    marketplaceId,
    role,
    activeTab,
    loggedInUserProfileType,
    loggedInUserName,
    currentMonth,
    setCurrentMonth,
    selectedDates,
    isPublishing,
    confirmPublishPopup,
    setConfirmPublishPopup,
    confirmContactPopup,
    setConfirmContactPopup,
    showReportPopup,
    setShowReportPopup,
    handlePublish,
    handleCreateContact,
    fetchMarketplaceCards,
}) => {
    const { t } = useTranslation('readyRoster');
    const loginResponse = JSON.parse(
        localStorage.getItem("loginResponse") || "{}"
    );

    const loggedInUserId = loginResponse.id;
    const loggedProfileType = loginResponse.profileType;
    console.log("viewCardbbbbb:", viewCard);


    const formatDate = (dateString: any) => {
        return new Date(dateString).toLocaleDateString("en-US", {
            month: "short",
            day: "numeric",
            year: "numeric",
        });
    };

    const isCardPublished = (card: MarketplaceCardResponseDto) => {
        return card?.readyRosterCard?.status === "PUBLISH" || card?.readyRosterCard?.status === "publish";
    };

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            size="5xl"
            className="max-h-[700px]"
        >
            <ModalContent onClick={(e) => e.stopPropagation()}>
                <ModalHeader className="text-xl font-semibold text-gray-800 flex items-center justify-between">
                    <span className="flex items-center gap-3">
                        {t("ready_roster_detail")}
                    </span> 
                </ModalHeader>

                <ModalBody className="py-1 h-[60vh] overflow-y-auto">
                    <div className="grid grid-cols-12 gap-6 h-full">
                        <div className="col-span-4 h-full flex justify-center">
                            <Card className="bg-red-50 shadow-md border border-gray-200 p-0 h-full w-[100%]">
                                <CardBody className="space-y-4 max-h-[400px]">
                                    <div className="flex items-center gap-3">
                                        <Avatar
                                            src={viewCard?.readyRosterCard?.fighter?.profileImage || undefined}
                                            name={
                                                !viewCard?.readyRosterCard?.fighter?.profileImage &&
                                                    viewCard?.readyRosterCard?.fighter?.firstName &&
                                                    viewCard?.readyRosterCard?.fighter?.lastName
                                                    ? `${viewCard.readyRosterCard?.fighter.firstName.charAt(
                                                        0
                                                    )}${viewCard.readyRosterCard?.fighter.lastName.charAt(0)}`
                                                    : "Fighter"
                                            }
                                            size="lg"
                                            className="bg-blue-100 text-blue-600"
                                        />
                                        <div className="flex flex-col">
                                            <h4 className="text-base font-medium text-gray-900">
                                                {viewCard?.readyRosterCard?.fighter?.firstName} {viewCard?.readyRosterCard?.fighter?.lastName}
                                            </h4>

                                            {loggedProfileType === "ADMIN" && (
                                                <>
                                                    <p className="text-sm text-gray-500">{viewCard?.readyRosterCard?.fighter?.email}</p>
                                                    <p className="text-sm text-gray-500">{viewCard?.readyRosterCard?.fighter?.phoneNumber}</p>
                                                </>
                                            )}
                                        </div>
                                    </div>

                                    <Divider />

                                    <div className="space-y-3">
                                        <h3 className="text-xs font-semibold text-gray-800 border-b pb-1">
                                            {t("profile_details")}
                                        </h3>
                                        <div className="grid grid-cols-2 gap-3">
                                            <div>
                                                <span className="text-xs text-gray-600 block">
                                                    {t("date_of_birth")}
                                                </span>
                                                <div className="text-sm text-gray-700">
                                                    {formatDate(viewCard?.readyRosterCard?.fighter?.dateOfBirth) || "-"}
                                                </div>
                                            </div>
                                            <div>
                                                <span className="text-xs text-gray-600 block">
                                                    {t("title_holder")}
                                                </span>
                                                <div className="text-sm text-gray-700">
                                                    {viewCard?.readyRosterCard?.fighter?.titleHolder ? t("yes") : t("no")}
                                                </div>
                                            </div>
                                            <div>
                                                <span className="text-xs text-gray-600 block">
                                                    {t("height")}
                                                </span>
                                                <div className="text-sm text-gray-700">
                                                    {viewCard?.readyRosterCard?.fighter?.height}{" "}
                                                    {viewCard?.readyRosterCard?.fighter?.heightUnit}
                                                </div>
                                            </div>
                                            <div>
                                                <span className="text-xs text-gray-600 block">
                                                    {t("weight")}
                                                </span>
                                                <div className="text-sm text-gray-700">
                                                    {viewCard?.readyRosterCard?.fighter?.weight}{" "}
                                                    {viewCard?.readyRosterCard?.fighter?.weightUnit}
                                                </div>
                                            </div>
                                            <div>
                                                <span className="text-xs text-gray-600 block">
                                                    {t("reach")}
                                                </span>
                                                <div className="text-sm text-gray-700">
                                                    {viewCard?.readyRosterCard?.fighter?.reach}{" "}
                                                    {viewCard?.readyRosterCard?.fighter?.reachUnit}
                                                </div>
                                            </div>
                                            <div>
                                                <span className="text-xs text-gray-600 block">
                                                    {t("stance")}
                                                </span>
                                                <div className="text-sm text-gray-700">
                                                    {viewCard?.readyRosterCard?.fighter?.stance || "-"}
                                                </div>
                                            </div>
                                            <div>
                                                <span className="text-xs text-gray-600 block">
                                                    {t("training_disciplines")}
                                                </span>
                                                <div className="text-sm text-gray-700">
                                                    {viewCard?.readyRosterCard?.fighter?.trainingDisciplines?.length
                                                        ? viewCard.readyRosterCard?.fighter.trainingDisciplines
                                                            .map((d) => formatSportName(d))
                                                            .join(", ")
                                                        : "-"}
                                                </div>
                                            </div>
                                            <div>
                                                <span className="text-xs text-gray-600 block">
                                                    {t("gender")}
                                                </span>
                                                <div className="text-sm text-gray-700">
                                                    {viewCard?.readyRosterCard?.fighter?.gender || "-"}
                                                </div>
                                            </div>
                                            <div>
                                                <span className="text-xs text-gray-600 block">
                                                    {t("weight_classes")}
                                                </span>
                                                <div className="text-sm text-gray-700">
                                                    {viewCard?.readyRosterCard?.fighter?.weightClasses?.length
                                                        ? viewCard.readyRosterCard?.fighter.weightClasses
                                                            .map((w) => formatSportName(w))
                                                            .join(", ")
                                                        : "-"}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </CardBody>
                            </Card>
                        </div>

                        <div className="col-span-8 h-full overflow-y-auto">
                            <div className="grid grid-cols-8 gap-4 h-94">
                                <div className="col-span-4 space-y-4">
                                    <div className="space-y-2">
                                        <h3 className="text-xs font-semibold text-gray-800 border-b pb-1">
                                            {t("financial_information")}
                                        </h3>
                                        <div className="grid grid-cols-2 gap-2">
                                            <div>
                                                <span className="text-xs text-gray-600 block">
                                                    {t("purse")}
                                                </span>
                                                <div className="text-sm text-gray-700">
                                                    {formatPurseText(viewCard?.readyRosterCard?.purse ?? "")}
                                                    {getCurrencySymbol(viewCard?.readyRosterCard?.currency ?? "")}
                                                </div>
                                            </div>
                                            <div>
                                                <span className="text-xs text-gray-600 block">
                                                    {t("currency")}
                                                </span>
                                                <div className="text-sm text-gray-700">
                                                    {viewCard?.readyRosterCard?.currency || "-"}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="space-y-2">
                                        <h3 className="text-xs font-semibold text-gray-800 border-b pb-1">
                                            {t("match_information")}
                                        </h3>
                                        <div className="grid grid-cols-2 gap-2">
                                            <div>
                                                <span className="text-xs text-gray-600 block">
                                                    {t("sport")}
                                                </span>
                                                <div className="text-sm text-gray-700">
                                                    {formatSportName(viewCard?.readyRosterCard?.sport ?? "") || "-"}
                                                </div>
                                            </div>
                                            <div>
                                                <span className="text-xs text-gray-600 block">
                                                    {t("preferred_ruleset")}
                                                </span>
                                                <div className="text-sm text-gray-700">
                                                    {formatSportName(viewCard?.readyRosterCard?.preferredRuleSet ?? "-")}
                                                </div>
                                            </div>
                                            <div>
                                                <span className="text-xs text-gray-600 block">
                                                    {t("weight_class")}
                                                </span>
                                                <div className="text-sm text-gray-700">
                                                    {formatWeightClassName(viewCard?.readyRosterCard?.weightClass ?? "-")}
                                                </div>
                                            </div>
                                            <div>
                                                <span className="text-xs text-gray-600 block">
                                                    {t("roster_status")}
                                                </span>
                                                <div className="text-sm text-gray-700">
                                                    {formatEnumString(viewCard?.readyRosterCard?.rosterStatus ?? "-")}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="space-y-2">
                                        <h3 className="text-xs font-semibold text-gray-800 border-b pb-1">
                                            {t("location_travel")}
                                        </h3>
                                        <div className="grid grid-cols-2 gap-2">
                                            <div>
                                                <span className="text-xs text-gray-600 block">
                                                    {t("location")}
                                                </span>
                                                <div className="text-sm text-gray-700">
                                                    {viewCard?.readyRosterCard?.location || "-"}
                                                </div>
                                            </div>
                                            <div>
                                                <span className="text-xs text-gray-600 block">
                                                    {t("travel_ready")}
                                                </span>
                                                <div className="text-sm text-gray-700">
                                                    {viewCard?.readyRosterCard?.travelReady ? t("yes") : t("no")}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="space-y-2">
                                        <h3 className="text-xs font-semibold text-gray-800 border-b pb-1">
                                            {t("validity")}
                                        </h3>
                                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                                            <div>
                                                <span className="text-xs text-gray-600 block">
                                                    {t("created_at")}
                                                </span>
                                                <div className="text-sm text-gray-700 mt-1">
                                                    {formatDate(viewCard?.readyRosterCard?.createdAt) || "-"}
                                                </div>
                                            </div>
                                            <div>
                                                <span className="text-xs text-gray-600 block">
                                                    {t("valid_upto")}
                                                </span>
                                                <div className="text-sm text-gray-700 mt-1">
                                                    {formatDate(viewCard?.readyRosterCard?.validUpto) || "-"}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-span-4 space-y-4">
                                    <div className="space-y-2">
                                        <h3 className="text-xs font-semibold text-gray-800 border-b pb-1">
                                            {t("availability")}
                                        </h3>
                                        <div className="grid grid-cols-5 gap-4">
                                            <CalendarView
                                                currentMonth={currentMonth}
                                                selectedDates={selectedDates}
                                                setCurrentMonth={setCurrentMonth}
                                            />
                                        </div>
                                    </div>

                                    <div className="space-y-1">
                                        <h3 className="text-xs font-semibold text-gray-800 border-b pb-1">
                                            {t("notes")}
                                        </h3>
                                        <div className="text-sm text-gray-700 mt-1 max-h-20 overflow-y-auto pr-1">
                                            {viewCard?.readyRosterCard?.notes || "-"}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </ModalBody>

                <ModalFooter className="py-3">
                    <div className="flex justify-between items-center w-full gap-4">
                        <div className="flex gap-2">
                            {/* Contact button */}
                            {role === "MANAGER" && activeTab === "all" && (
                                <>
                                    {viewCard?.readyRosterCard?.contacted === false && new Date(viewCard.readyRosterCard?.validUpto) >= new Date() && (
                                        <Button
                                            color="primary"
                                            size="sm"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                setConfirmContactPopup(true);
                                            }}
                                        >
                                            {t("contact")}
                                        </Button>
                                    )}
                                    {viewCard?.readyRosterCard?.contacted === true && (
                                        <Button
                                            color="default"
                                            size="sm"
                                            disabled
                                            className="bg-gray-300 text-gray-700 cursor-not-allowed"
                                        >
                                            {t("contacted")}
                                        </Button>
                                    )}
                                </>
                            )}

                            {role === "FIGHTER" && activeTab === "myCards" && (
                                <Button
                                    color={
                                        new Date(viewCard?.readyRosterCard?.validUpto ?? "") < new Date()
                                            ? "danger"
                                            : isCardPublished(viewCard as MarketplaceCardResponseDto)
                                                ? "default"
                                                : "success"
                                    }
                                    size="sm"
                                    onClick={() => {
                                        if (
                                            new Date(viewCard?.readyRosterCard?.validUpto ?? "") >= new Date() &&
                                            !isCardPublished(viewCard as MarketplaceCardResponseDto) &&
                                            marketplaceId
                                        ) {
                                            setConfirmPublishPopup(true);
                                        }
                                    }}
                                    disabled={
                                        new Date(viewCard?.readyRosterCard?.validUpto ?? "") < new Date() ||
                                        isCardPublished(viewCard as MarketplaceCardResponseDto) ||
                                        isPublishing
                                    }
                                    isLoading={isPublishing}
                                >
                                    {new Date(viewCard?.readyRosterCard?.validUpto ?? "") < new Date()
                                        ? t("expired")
                                        : isCardPublished(viewCard as MarketplaceCardResponseDto)
                                            ? t("published")
                                            : isPublishing
                                                ? t("publishing")
                                                : t("publish")}
                                </Button>
                            )}
                        </div>

                        <div className="flex gap-4">
                            {activeTab !== "myCards" && loggedInUserProfileType !== "ADMIN" && loggedInUserName !== viewCard?.readyRosterCard?.fighter?.email && (
                                <>
                                    {viewCard?.readyRosterCard?.reported === true ? (
                                        <Button
                                            color="default"
                                            size="sm"
                                            disabled
                                            className="bg-gray-300 text-gray-700 cursor-not-allowed"
                                        >
                                            {t("reported")}
                                        </Button>
                                    ) : (
                                        <Button
                                            variant="solid"
                                            size="sm"
                                            onPress={() => setShowReportPopup(true)}
                                            className="flex items-center gap-1 bg-red-500 text-white hover:bg-red-600"
                                        >
                                            <ExclamationTriangleIcon className="w-4 h-4" />
                                            {t("report_abuse")}
                                        </Button>
                                    )}
                                </>
                            )}

                            <Button variant="flat" onClick={onClose} size="sm">
                                {t("close")}
                            </Button>
                        </div>
                    </div>

                    <ConfirmModal
                        isOpen={confirmContactPopup}
                        onClose={() => setConfirmContactPopup(false)}
                        cardTitle={t("confirm_contact")}
                        cardDescription={t("confirm_contact_description")}
                        buttonText={t("confirm")}
                        onConfirm={() => handleCreateContact(viewCard, { stopPropagation: () => { } })}
                    />

                    <ConfirmModal
                        isOpen={confirmPublishPopup}
                        onClose={() => setConfirmPublishPopup(false)}
                        cardTitle={t("confirm_publish")}
                        cardDescription={t("confirm_publish_description")}
                        buttonText={t("confirm")}
                        onConfirm={() => {
                            if (marketplaceId) handlePublish(marketplaceId.toString());
                        }}
                    />

                    {viewCard?.readyRosterCard?.fighter?.id && marketplaceId && (
                        <ReportAbusePopup
                            isOpen={showReportPopup}
                            onClose={() => setShowReportPopup(false)}
                            onSubmit={(reportType, reportDescription) => {
                                setShowReportPopup(false);
                                onClose();
                                if (fetchMarketplaceCards) fetchMarketplaceCards();
                            }}
                            cardId={marketplaceId.toString()}
                            type="MARKETPLACECARDS"
                            reportedTo={viewCard.readyRosterCard?.fighter.id ?? ""}
                        />

                    )}
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};

export default ViewModal;
